import { Component} from '@angular/core';
import { LoginApiMasterService } from './login-layout/Service/login-api-master.service';
import { environment } from 'src/environments/environment';
import config from '../assets/app-env-config.json';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
    title = 'EductionApp';

    appVersion = config.version;
   
    constructor(private loginService: LoginApiMasterService){


    // this.initLoginConfig()

    }

    ngOnInit() {
  
  
      }


    async initLoginConfig() {
  const oneLogin = await this.loginService.readConfigsingleLoginForAllUser('assets/config.json');
  if(oneLogin){

     sessionStorage.setItem("OneLoginUser", 'true');

  }
  else{

     sessionStorage.setItem("OneLoginUser", 'false');

  }
  const result = await this.loginService.readConfigSSOLogin('assets/config.json');
  
  if (result) {
    sessionStorage.setItem('loginWithSSO', 'true');
 

  } else {
    sessionStorage.setItem('loginWithSSO', 'false');
    
  }
}



 
}

